define('app/filters/controls/AddFilterControl',['require','glu/itemView','hbs!./AddFilterControl.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView');

	return ItemView.extend({
		template: require('hbs!./AddFilterControl.hbs'),
		initialize: function() {
			this.model.setArity(0);
		}
	});

});

